export default "__VITE_ASSET__DkzJNTCI__"